{
    "global": {
        "TITLE": "Comunidad de Educadores",
        "UNIT": "Unidad",
        "FORUM": "Foro",
        "COMMENT": "Comentar",
        "DISCARD": "Descartar",
        "SAVE": "Guardar",
        "REPLY": "Responder",
        "SHOW_REPLIES": "Ver respuestas",
        "HIDE_REPLIES": "Ocultar respuestas",
        "CANCEL": "Cancelar",
        "RESUME": "Resumen",
        "DETAIL": "Detalle",
        "PARTICIPANTS": "Participantes",
        "TOTAL_DELIVERED": "Total entregados: ",
        "DELIVERY_DATE": "Fecha de entrega: ",
        "ACTIVITY_STATUS": "Estado de la actividad: ",
        "PARTICIPANT": "Participante",
        "STATUS": "Estado",
        "LAST_MODIFICATION": "Última modificación",
        "EXPIRES_IN": "Expira en ",
        "EXPIRED": "Expirado",
        "LATE": "Tarde",
        "NEVER": "Nunca",
        "SAVE_CHANGES": "Guardar cambios",
        "PUBLISH": "Publicar",
        "EMAIL": "Email",
        "DEBATE": "Debate",
        "WITHOUT_ACTIVITY": "Sin actividad",
        "ACTIVITY": "Actividad",
        "OPEN": "Abierta",
        "OVERDUE": "Vencida",
        "RETURN": "Devolucion",
        "CONFIRM": "Confirmar"
    },
    "comments": {
        "COMMENT_HAS_BEEN_REMOVED": "Este comentario ha sido eliminado",
        "WISH_DELETE_COMMENT": "¿Deseas eliminar este comentario?",
        "DELETE_COMMNET": "Borrar comentario",
        "DELETE_THREAD": "Borrar hilo",
        "COMMENT_DELETED": "Comentario eliminado",
        "ERROR_SENDED": "Error al enviar comentario",
        "ERROR_DELETE_COMMENT": "Error al intentar eliminar el comentario",
        "ERROR_EDIT_COMMENT": "Error al editar el comentario",
        "ERROR_LIKE_COMMENT": "Error al likear el comentario"
    },
    "file": {
        "UPLOAD_FILE": "Subir archivo",
        "MAX_FILE_WEIGHT": "El peso máximo es de 600mb y los formatos permitidos son DOC, DOCX, PPT, PDF, PPTM, PPTX, PDF, PNG, JPG, JPEG, GIF, XLS, XLSX.",
        "uploading":{ 
            "TITLE": "Estamos subiendo tu archivo",
            "MESSAGE": "No cierres ni actualices el navegador."
        },
        "uploading_error":{
            "TITLE": "No pudimos subir el archivo",
            "MESSAGE": "Parece que el achivo que intentas subir no cumple los parámetros. Revisa que no pese más de 600MB y que tenga alguno de los siguientes formatos: PDF, DOC, Excel.",
            "ERROR": "Error al intentar subir archivo"
        },
        "UPLOADED_FILES": "Archivos subidos",
        "emptyState": {
            "TITLE": "Todavía no has subido archivos",
            "MESSAGE": "Sube el archivo desde tu ordenador"

        },
        "DELETE_FILE": "Eliminar archivo"
    },
    "login": {
        "TITLE": "Bienvenido",
        "instructions": {
            "FIRST_LOGIN": "Ingresa tu mail y la contraseña que te enviamos para iniciar tu registro",
            "DEFAULT": "Ingresa tu mail y contraseña para ingresar",
            "TERMS_AND_CONDITIONS": "Haciendo click en “Continuar” aceptas los ",
            "RECOVERY_PASSWORD": "Por favor, ingresa primero su email para poder recuperar su contraseña.",
            "CREATE_ACCOUNT": "¿No tienes cuenta?",
            "REGISTER": "Registrate"
        },
        "inputs": {
            "EMAIL": "Email",
            "PASSWORD": "Contraseña"
        },
        "errors": {
            "INCORRECT_USERNAME_OR_PASSWORD": "Usuario o contraseña incorrectos"
        },
        "actions": {
            "FORGOT_PASSWORD": "¿Olvidaste tu contraseña?",
            "CONTINUE": "Continuar",
            "TERMS_AND_CONDITIONS": "Términos y Condiciones y las Políticas de Privacidad",
            "CANCEL": "Cancelar",
            "PROCESSING": "Procesando"
        },
        "recoveryPassword": {
            "TITLE": "¿Olvidaste tu contraseña?",
            "INSTRUCTION" : "No hay problema, te enviaremos una nueva a: "
        }
    },
    "pickrole": {
        "TITLE": "Cambiar el perfil",
        "INSTRUCTION": "Selecciona el perfil con el que quiere ingresar:"
    },
    "nav": {
        "HOME": "Inicio",
        "COURSES": "Cursos",
        "RESOURCES": "Recursos",
        "HELP": "Ayuda",
        "NOTIFICATIONS" : "Notificaciones",
        "PROFILES": "Perfiles",
        "LOG_OUT": "Cerrar sesión",
        "SETTINGS": "Ajustes",
        "ERROR": "Ocurrió un error al intentar cambiar de perfil. Intente nuevamente."
    },
    "course": {
        "status": {
            "NotStarted": "No comenzado",
            "InProgress": "En progreso", 
            "Finished" : "Finalizado",
            "COURSE_FINISHED": "Este curso ha finalizado."
        },
        "card":{
            "CONTINUE": "Ir al curso"
        },
        "tree": {
            "COURSE_CONTENT": "Contenido del curso",
            "PRACTICE": "Práctica con tus estudiantes",
            "BOARD": "Novedades e Intercambio",
            "TUTORIAL": "Ver tutorial"
        },
        "intro":{
            "TITLE": "Introduccion al Programa",
            "END_DATE": "Finaliza ",
            "UNITS": "Unidades",
            "MODULES": "Módulos",
            "CONGRATULATIONS": "¡Felicitaciones! Has completado todas las unidades.",
            "CONGRATULATIONS_REMINDER": "Recuerda que puedes seguir accediendo a los materiales del curso todas las veces que necesites."
        },
        "actions": {
            "CONTINUE_COURSE": "Continuar curso",
            "START_COURSE": "Comenzar curso", 
            "COMPLETED_COURSE": "¡Finalizaste!",
            "RETURN": "Volver",
            "VIEW_REPORT": "Ver reporte"
        },
        "errors": {
            "ERROR_LOADING": "Error al cargar el curso"
        }
    },
    "date" : {
        "params": {
            "second": "segundo",
            "seconds": "segundos",
            "minute": "minuto",
            "minutes": "minutos",
            "hour": "hora",
            "hours": "horas",
            "day": "día",
            "days": "días",
            "week": "semana",
            "weeks": "semanas"
        }
    },
    "module": {
        "resume": {
            "MANDATORY_ACTIVITY_FINISHED": "Actividades obligatorias completadas",
            "OPTATIVE_ACTIVITY_FINISHED": "Actividades opcionales completadas",
            "TOTAL_STUDENTS": "estudiantes totales",
            "FINISHED_STUDENTS": "estudiantes finalizaron",
            "STARTED_STUDENTS": "estudiantes comenzaron",
            "NOT_STARTED_STUDENTS": "estudiantes no comenzaron"
        },
        "status": {
            "COMING_SOON": "Próximamente",
            "IN_PROGRESS": "En curso",
            "AVAILABLE": "Disponible"
        },
        "actions": {
            "BACK_TO_COURSE_START": "Vovler al inicio del curso",
            "PREVIOUS": "Anterior",
            "NEXT": "Siguiente"
        },
        "activities": {
            "statuses":{
                "CONTENT_PENDING_MANDATORY": "Esta actividad es obligatoria",
                "CONTENT_PENDING_OPTATIVE": "Esta actividad es opcional",
                "CONTENT_PENDING_OUT_TIME": "Recuerda que aún tienes esta actividad por completar",
                "CONTENT_FINISHED_IN_TIME": "¡Felicitaciones! Has completado esta actividad",
                "CONTENT_FINISHED_OUT_TIME": "¡Muy bien! Ya estas al día con esta actividad"
            }
        }
    },
    "tutor": {
        "detail": {
            "status": {
                "All": "Todos",
                "FinishedInTime": "Entregado",
                "FinishedOutOfTime": "Entregado fuera de término",
                "NotFinished": "No entregado"
            }
        },
        "report":{
            "userSituation": {
                "END_NONE_CONTENT": "No finalizó ningún contenido",
                "END_SOME_CONTENT": "Finalizó algún contenido",
                "END_ALL_CONTENT": "Finalizó todos los contenidos"
            },
            "activityStatus": {
                "FinishedInTime": "Entregado",
                "FinishedOutOfTime": "Entregado fuera de termino",
                "NotFinished": "No entregado"
            }
        }
    },
    "role": {
        "LEARNINGUSER": "Estudiante",
        "TUTOR": "Tutor",
        "REFERENT": "Referente",
        "EDITOR": "Editor regional de contenido",
        "PEDAGOGUE": "Responsable pedagógico local",
        "MODERATOR": "Moderador de la comunidad"
    },
    "preInscription": {
        "error": {
            "EMAIL_IS_MANDATORY": "Es necesario el e-mail para continuar con el proceso",
            "PREINSCRIPTION_NOT_FOUND": "La preinscripción a la que intentas acceder no existe",
            "PREINSCRIPTION_IS_FULL": "La preinscripción a la que intentas acceder está completa",
            "PREINSCRIPTION_TIMED_OUT": "La preinscripción a la que intentas acceder ha finalizado",
            "NAMES_ARE_MANDATORY": "Los campos ‘Nombre' y 'Apellido’ son obligatorios ",
            "STAGE_ONE_NOT_FOUND": "No puedes acceder a la segunda etapa de la preinscripción sin haber completado la primera",
            "STAGE_ALREADY_COMPLETED": "Ya has completado previamente esta etapa de la preinscripción"
        }
    },
    "home": {
        "TITLE": "Te damos la bienvenida a ",
        "COURSES": "Tus cursos",
        "RESOURCES": "Recursos destacados"
    },
    "myCourses": {
        "TITLE" : "Programas en curso"
    },
    "resources": {
        "filters": {
            "TOPIC": "Temática",
            "CATEGORY": "Categoría" 
        },
        "titles": {
            "LAST_RESOURCES_VIEWED": "Últimos recursos vistos",
            "HIGHLIGHTED_RESOURCES": "Recursos destacados",
            "NEW_RESOURCES": "Nuevos recursos",
            "FILTERED_RESOURCES": "Recursos filtrados"
        }
    },
    "forum":{
        "actions": {
            "BACK_TO_MODULE": "Volver al módulo",
            "LIKE": "Me gusta",
            "REPLY": "Responder",
            "NEW_DISCUSSION": "+ Nuevo debate"
        },
        "DELIVERY_DATE": "Fecha de entrega: ",
        "CORRECT_NEW_DISCUSSION": "Creaste un nuevo tema de debate",
        "instructions": {
            "COURSE_FINISHED": "Podrás seguir viendo todos los comentarios del foro aunque ya no es posible participar."
        },
        "errors": {
            "LIKE_HEADER": "Error al likear header",
            "INVALID_TITLE": "Debe ingresar un título válido.",
            "ERROR_POST_NEW_DISCUSSION": "Error al publicar tema de debate",
            "EDIT_HEADER": "Error al editar tema de debate",
            "LOAD_RESUME": "Ocurrió un error al cargar el resumen",
            "LOAD_DETAIL": "Ocurrió un error al cargar el detalle"
        },
        "tutorView": {
            "TITLE": "Temas de debate",
            "TOPIC_OF_DISCUSSION": "Tema de debate",
            "CREATED_BY": "Creado por",
            "LAST_ANSWER": "Última respuesta",
            "NUMBER_OF_RESPONSES": "Cantidad de respuestas"
        },
        "emptyState": {
            "TITLE": "Todavía no hay temas de debate",
            "TUTOR_MESSAGE": "Recuerda abrir el tema de debate para que tu grupo pueda participar del foro.",
            "MESSAGE": "En breve tu tutor inaugurará el foro para que puedas participar."
        },
        "history": {
            "DETAIL_TITLE": "Detalle de entrega",
            "COMMENT_HISTORY": "Historial de comentarios"
        }
    },
    "activity": {
        "LOAD_CONTENT": "Cargando contenido ...",
        "LAST_RETURN": "Última devolución de tu entrega",
        "status": {
            "done":{
                "TITLE": "Esta actividad se encuentra entregada.",
                "INFO": "Si deseas modificar tu entrega puedes subir más archivos o eliminar los que ya has subido."
            },
            "pending": {
                "TITLE": "Esta actividad se encuentra pendiente.",
                "INFO": "Sube archivos desde tu ordenador. Recuerda que el peso máximo es de 600MB y los formatos permitidos son DOC, DOCX, PPT, PDF, PPTM, PPTX, PDF, PNG, JPG, JPEG, GIF, XLS, XLSX."
            },
            "finished":{
                "TITLE": "Este curso ha finalizado",
                "INFO": "Ya no es posible modificar tu entrega."
            }
        },
        "CONFIRM_DELIVERY": "Confirmar entrega",
        "CONTINUE_EDITING": "Continuar editando",
        "DISCARD_CHANGES": "Descartar cambios",
        "DELETE_DELIVERY": "Eliminar entrega",
        "sendActivity": {
            "TITLE": "¡Muy bien!<br>Estás a un paso de finalizar esta actividad.",
            "INFO": "Confirmando tu entrega, tu actividad quedará registrada como finalizada.<br>Recuerda que podrás seguir agregando archivos o editar los que ya subiste."
        },
        "confirmChanges": {
            "TITLE": "¿Deseas guardar los cambios?",
            "INFO": "Has editado los archivos de tu entrega. Confirma si deseas que consideremos estos archivos para la entrega de tu actividad."
        },
        "discardChanges": {
            "TITLE": "¿Cancelar edición?",
            "INFO": "Si cancelas la edición, los cambios que hayas hecho a tu entrega no se guardarán."
        },
        "deleteActivity": {
            "TITLE": "¿Deseas eliminar tu entrega?",
            "INFO": "Ten en cuenta que si eliminas todos los archivos, tu entrega quedará marcada nuevamente como no entregada."
        },
        "fileUploading": {
            "TITLE": "Estamos subiendo tu archivo",
            "INFO": "No cierres ni actualices el navegador."
        },
        "removeFile": {
            "TITLE": "¿Estás seguro que deseas eliminar este archivo?",
            "INFO": "Luego de guardar los cambios, el archivo ya no formará parte de tu entrega"
        },
        "errorFile": {
            "TITLE": "No pudimos subir el archivo",
            "INFO": "Parece que el achivo que intentas subir no cumple los parámetros.<br>Revisa que no pese más de 600 MB y que tenga alguno de los siguientes formatos: PDF, DOC, Excel."
        },
        "feedback":{
            "SENT_CORRECTLY": "Feedback enviado correctamente",
            "ERROR": "Error al enviar feedback"
        },
        "ERROR_CONFIRM": "Error al confirmar la entrega. Tus cambios no se guardaron",
        "ERROR_DELETE_FILE": "Error al intentar eliminar archivo",
        "ERROR_GET_FILES": "Ocurrió un error al intentar obtener tus archivos",
        "ERROR_LOAD_SUMMARY": "Ocurrió un error al cargar el resumen",
        "ERROR_LOAD_DETAIL": "Ocurrió un error al cargar el detalle"
    }
}